<script>
    import { onMount, tick } from "svelte";
    import { createEventDispatcher } from "svelte";
    import Chart from 'chart.js/auto';
    import Gradient from "../../../services/gradient.js";


    let {findingCount = {}, handleAdvancedSearch = (x)=>x, advancedSearchFilter} = $props();

    let kinds = [
        "AD",
        "ASVS",
        "CVE",
        "INFO",
        "LEAK",
        "NVT",
        "EOL",
        "DMARC",
        "SPF",
        "M365",
        "CODE"
    ]
    let labels = {
        "AD": "AD",
        "ASVS": "ASVS",
        "CVE": "CVE",
        "INFO": "INFO",
        "LEAK": "LEAK",
        "NVT": "NVT",
        "EOL": "EOL",
        "DMARC": "DMARC",
        "SPF": "SPF",
        "M365": "M365",
        "CODE": "CODE"
    }

    let canvas = $state();
    let chart;
    let totals = $derived(findingCount);
    let total_count = $derived.by(()=>getTotalCount(findingCount));
    let gradientArray = $derived.by(()=>getColorsArray(total_count));

    const getTotalCount = (count) => {
        //sorry not sorry
        let the_final_countdown = 0
        for(let [key, value] of Object.entries(count)){
            if(value > 0) the_final_countdown++;
        }
        return the_final_countdown;
    }

    const getColorsArray = (count) => {
        let colors = new Gradient()
            //.setColorGradient("#B10c52", "#230B0C")
            .setColorGradient("#343a40","#3c8dbc") // opcion 1
            .setMidpoint(((count <= 2) ? 2 : count))
            .getColors();
        ;
        for(let [index, color] of colors.entries()){
            colors[index] = color + "AE";
        }
        return colors;
    }

    onMount(async () => {
        await tick();

        let context  = canvas.getContext('2d');

        let chartData = {
            labels   : [],
            datasets : {
                backgroundColor : gradientArray,
                data: [],
            },
        }

        for (const s of kinds) {
            totals[s] = findingCount[s];
        }

        totals = Object.entries(totals).sort((a,b)=>b[1]-a[1]);

        for (const kv of totals) {
            if(kv[1] > 0){
                chartData.labels.push(labels[kv[0]]);
                chartData.datasets.data.push(kv[1]);
            }
        }

        chart = new Chart(context, {
            type: 'bar',
            options: {
                barThickness: 50,
                // Elements options apply to all of the options unless overridden in a dataset
                // In this case, we are setting the border of each horizontal bar to be 2px wide
                elements: {
                    bar: {
                        inflateAmount: 1,
                        borderWidth: 0,
                        borderRadius: 2
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                aspectRatio: 1,
                plugins:{
                    legend: {
                        display: false,
                        position: 'bottom',
                        labels: {
                            font: {
                                fontFamily: 'Montserrat',
                                size: 12
                            }
                        }
                    },
                },
                title: {
                    display: false,
                },
                animation : {
                    animateScale: true,
                    animateRotate: true
                },
                scales: {
                    y: {
                        beginAtZero : true,
                        min: 0,
                        ticks: {
                            stepSize    : 1,
                            font: {
                                family: 'Montserrat'
                            }
                        }
                    },
                    x: {
                        ticks: {
                            font: {
                                family: 'Montserrat'
                            },

                            display: true,
                            maxRotation: 0
                        }
                    }
                },
                onHover : (event) => {
                    canvas.style.cursor = "pointer";
                },
                onClick: (event)=> {
                    handleAdvancedSearch({detail:{...advancedSearchFilter, vulnerability__id__ilike: event.chart.tooltip.title[0]}});
                }
            },
            data : {
                labels  : chartData.labels,
                datasets: [chartData.datasets],
                borderWidth: 2,
                borderRadius: 5,
                borderSkipped: false,
            },
        });
    });
</script>
<style>
    /*#chart-vuls-by-severity {
        height: 250px !important;
        margin: 0 auto;
        width: 808px;
    }*/
</style>
<canvas bind:this={canvas} id="chart-vuls-by-severity" class:chart-has-no-data="{total_count < 1}" ></canvas>
